export const verifyNullValue = ({ value, param }) => value === null ? '' : value[param]